const firebaseConfig = {
  apiKey: "AIzaSyAnEROoj7KzUm70TKJNSNVowLW9PlogXmE",
  authDomain: "smartsapp-ba40f.firebaseapp.com",
  databaseURL: "https://smartsapp-ba40f.firebaseio.com",
  projectId: "smartsapp-ba40f",
  storageBucket: "smartsapp-ba40f.appspot.com",
  messagingSenderId: "166512134514",
  appId: "1:166512134514:web:dc6290fa13ce6765fa35eb",
  measurementId: "G-MKLBF3R7KY",
};

export default firebaseConfig;
